import {makeRequest} from "./baseApi";
import {getTokens} from "@/shared/utils/systemUtils/systemUtils";
import {getBaseHost, getClientId, getCPanelUrl, getMainAppHost} from "../utils/url/url";
import {parseResponseDefault} from "./not-sorted.utils";
import {APIUrls} from "../utils/appServer/appServer";

export const fetchLegacyUserInfo = async () => {
  const { refreshToken } = getTokens();
  if (refreshToken) {
    const userinfo = await makeRequest({
      // url: "user/info/",
      // impl more stable API call when cors will be resolved
      url: getCPanelUrl() + "/connect/legacy-userinfo",
      type: "get",
      parseResponse: parseResponseDefault
    });
    return userinfo;
  }
  return undefined;
};


export function makeOAuthRequest() {
  const authParams = encodeURIComponent(
    "/connect/authorize?response_type=code" +
    "&client_id=" +
    getClientId() +
    "&redirect_uri=" +
    encodeURIComponent(getMainAppHost() + APIUrls.authCallback) +
    "&scope=" +
    encodeURIComponent(
      "user_info writings search " + "studycenter subscriptions offline_access",
    ) +
    "&grant_type=authorization_code" +
    "&state=test",
  );

  const loginURL = `${getCPanelUrl()}/accounts/login/?next=${authParams}`;
  return window.open(loginURL);
}
